import { IoDocumentOutline } from "react-icons/io5";
import "./DownloadPDF.scss";
const DownloadPDF = ({ pdfUrl }: { pdfUrl: string }) => {
  const handleOpen = () => {
    window.open(pdfUrl, "_blank");
  };

  return (
    <button onClick={handleOpen} className="Download-Button">
      <IoDocumentOutline />
      Preuzmite
    </button>
  );
};

export default DownloadPDF;
